function transformItem2Dto(item) {
  const dto = {
    ...item
  };
  dto['productRegistrationGroupID'] = item.id;
  delete dto.id;
  return dto;
}

function transformDto2Item(dto) {
  const item = {
    ...dto,
    id: dto['productRegistrationGroupID']
  };
  delete item['productRegistrationGroupID'];
  return item;
}

export const apiOverrides = { transformItem2Dto, transformDto2Item };

export const storeExtensions = {
  actions: {},
  getters: {},
  mutation: {},
  state: {}
};
